var selectTheme = function () { return function (state) { return state.theme.type; }; };
export default selectTheme;
